import { render, staticRenderFns } from "./EnglishResumePreviewDocPage2.vue?vue&type=template&id=2cd27c72"
import script from "./EnglishResumePreviewDocPage2.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumePreviewDocPage2.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports